/* ============================================================
   BEATO GLP-1 — BEST VERSION OF YOU
   Shared JavaScript: animations, chart, accordion, countup
   ============================================================ */

(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Utility: IntersectionObserver factory                               */
  /* ------------------------------------------------------------------ */
  function onceInView(el, callback, options) {
    if (!el) return;
    var opts = Object.assign({ threshold: 0.2 }, options);
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          callback(el);
          obs.disconnect();
        }
      });
    }, opts);
    obs.observe(el);
    return obs;
  }

  /* ------------------------------------------------------------------ */
  /* Reveal (fade-up on scroll)                                          */
  /* ------------------------------------------------------------------ */
  function initReveal() {
    var els = document.querySelectorAll('.bvoy-reveal');
    els.forEach(function (el) {
      onceInView(el, function (target) {
        var delay = parseInt(target.getAttribute('data-bvoy-delay') || '0', 10);
        setTimeout(function () {
          target.classList.add('bvoy-is-visible');
        }, delay);
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* CountUp                                                             */
  /* ------------------------------------------------------------------ */
  function countUp(el, to, duration) {
    var start = null;
    function tick(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(eased * to) + (el.getAttribute('data-bvoy-suffix') || '');
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-bvoy-countup]');
    els.forEach(function (el) {
      var to       = parseInt(el.getAttribute('data-bvoy-countup'), 10);
      var duration = parseInt(el.getAttribute('data-bvoy-duration') || '1800', 10);
      onceInView(el, function (target) {
        countUp(target, to, duration);
      }, { threshold: 0.4 });
    });
  }

  /* ------------------------------------------------------------------ */
  /* HeroThoughts staggered reveal                                       */
  /* ------------------------------------------------------------------ */
  function initHeroThoughts() {
    var container = document.querySelector('.bvoy-thoughts');
    if (!container) return;

    var items = container.querySelectorAll('.bvoy-thoughts__item');
    var triggered = false;

    onceInView(container, function () {
      if (triggered) return;
      triggered = true;
      items.forEach(function (item, i) {
        setTimeout(function () {
          var before = item.querySelector('.bvoy-thoughts__before');
          var arrow  = item.querySelector('.bvoy-thoughts__arrow');
          var after  = item.querySelector('.bvoy-thoughts__after');
          if (before) before.classList.add('is-revealed');
          if (arrow)  arrow.classList.add('is-revealed');
          if (after)  after.classList.add('is-revealed');
        }, 400 + i * 550);
      });
    }, { threshold: 0.5 });
  }

  /* ------------------------------------------------------------------ */
  /* Weight Loss Chart (SVG, animated clip-path)                         */
  /* ------------------------------------------------------------------ */
  function initWeightLossChart() {
    var container = document.querySelector('.bvoy-chart-wrapper');
    if (!container) return;

    var svg        = container.querySelector('.bvoy-chart-svg');
    var clipRect   = container.querySelector('#bvoy-chart-clip-rect');
    var dot        = container.querySelector('#bvoy-chart-dot');
    var dotGlow    = container.querySelector('#bvoy-chart-dot-glow');
    var label      = container.querySelector('#bvoy-chart-label');
    var labelText  = container.querySelector('#bvoy-chart-label-text');

    if (!svg || !clipRect) return;

    var points = [
      { m: 0, v: 0 }, { m: 1, v: 4 }, { m: 2, v: 9 },
      { m: 3, v: 14 }, { m: 4, v: 18 }, { m: 5, v: 22 }, { m: 6, v: 25 }
    ];
    var W = 520, H = 280, PAD = { l: 44, r: 20, t: 20, b: 36 };

    function scX(m) { return PAD.l + (m / 6) * (W - PAD.l - PAD.r); }
    function scY(v) { return H - PAD.b - (v / 30) * (H - PAD.t - PAD.b); }

    var fullWidth = W - PAD.l - PAD.r;

    onceInView(container, function () {
      var startTime = null;
      var dur = 2000;

      function tick(ts) {
        if (!startTime) startTime = ts;
        var raw = Math.min((ts - startTime) / dur, 1);
        var p   = 1 - Math.pow(1 - raw, 3); // ease-out cubic

        // Advance clip rect
        if (clipRect) {
          clipRect.setAttribute('width', PAD.l + fullWidth * p);
        }

        // Animated dot position
        var idxF  = p * (points.length - 1);
        var idx   = Math.min(points.length - 2, Math.floor(idxF));
        var local = idxF - idx;
        var cx    = scX(points[idx].m + (points[idx + 1].m - points[idx].m) * local);
        var cy    = scY(points[idx].v + (points[idx + 1].v - points[idx].v) * local);
        var curV  = points[idx].v + (points[idx + 1].v - points[idx].v) * local;

        if (dot)     { dot.setAttribute('cx', cx); dot.setAttribute('cy', cy); }
        if (dotGlow) { dotGlow.setAttribute('cx', cx); dotGlow.setAttribute('cy', cy); }

        if (label && labelText) {
          var lx = Math.min(cx, W - 110);
          var ly = Math.max(cy - 46, 6);
          label.setAttribute('transform', 'translate(' + lx + ',' + ly + ')');
          labelText.textContent = curV.toFixed(1) + '% lost';
        }

        if (raw < 1) requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    }, { threshold: 0.3 });
  }

  /* ------------------------------------------------------------------ */
  /* Accordion                                                           */
  /* ------------------------------------------------------------------ */
  function initAccordion() {
    var items = document.querySelectorAll('.bvoy-accordion__item');
    items.forEach(function (item) {
      var trigger = item.querySelector('.bvoy-accordion__trigger');
      if (!trigger) return;
      // Make sure it never submits a surrounding product form.
      trigger.setAttribute('type', 'button');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isOpen = item.classList.contains('is-open');
        var parent = item.closest('.bvoy-accordion');

        // Close all siblings (single-open behaviour, matching the design)
        if (parent) {
          parent.querySelectorAll('.bvoy-accordion__item.is-open').forEach(function (sibling) {
            sibling.classList.remove('is-open');
            var sTrig = sibling.querySelector('.bvoy-accordion__trigger');
            if (sTrig) sTrig.setAttribute('aria-expanded', 'false');
          });
        }

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Smooth scroll for in-page anchor links (#bvoy-how, #bvoy-program…)   */
  /* Offsets by the fixed nav height so the target isn't hidden under it. */
  /* ------------------------------------------------------------------ */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var hash = link.getAttribute('href');
      if (!hash || hash === '#') return;

      var target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();

      // Offset = theme sticky header height + our own nav height (4rem),
      // so the target heading isn't hidden behind either bar.
      var root = document.querySelector('.bvoy-root');
      var themeHeader = 0;
      if (root) {
        var v = getComputedStyle(root).getPropertyValue('--bvoy-theme-header-height');
        themeHeader = parseInt(v, 10) || 0;
      }
      var navHeight = 64; // .bvoy-nav-spacer (4rem)
      var offset = themeHeader + navHeight;

      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Position our nav BELOW the theme's own sticky header.               */
  /* Measures the theme's sticky header height and exposes it as the     */
  /* CSS var --bvoy-theme-header-height on every .bvoy-root.             */
  /* ------------------------------------------------------------------ */
  function measureThemeHeader() {
    // Locate the theme's own sticky header. In this (Focal) theme the sticky
    // element is the section wrapper `#shopify-section-…` that contains the
    // `.section-header` / `.header` markup. We find it, then measure the
    // bottom edge of whatever is pinned at the top (header, and the
    // announcement bar above it if it's also sticky).
    // The header is the <store-header class="header"> element; the actual
    // sticky element is its wrapping `#shopify-section-…` div.
    var headerEl = document.querySelector('store-header.header, store-header, .header[role="banner"], .header');
    var headerSection = headerEl ? headerEl.closest('[id^="shopify-section-"]') : null;

    var bottom = 0;

    if (headerSection) {
      var rect = headerSection.getBoundingClientRect();
      // At the top of the page the sticky header sits in its natural place,
      // so its bottom edge IS the offset our nav needs. Once pinned it stays
      // at the same bottom edge, so this stays correct after scrolling too.
      bottom = rect.bottom;

      // Also account for a sticky announcement bar sitting above the header.
      var annEl = document.querySelector('.section--announcement-bar, .announcement-bar');
      var annSection = annEl ? annEl.closest('[id^="shopify-section-"]') : null;
      if (annSection) {
        var aStyle = window.getComputedStyle(annSection);
        if (aStyle.position === 'sticky' || aStyle.position === 'fixed') {
          var aRect = annSection.getBoundingClientRect();
          // If the announcement bar is still on screen above the header,
          // the header bottom already includes it; nothing to add. If the
          // announcement bar scrolled away, header pins to top — also fine.
          if (aRect.bottom > bottom) bottom = aRect.bottom;
        }
      }
    }

    var height = Math.max(0, Math.round(bottom));

    document.querySelectorAll('.bvoy-root').forEach(function (root) {
      root.style.setProperty('--bvoy-theme-header-height', height + 'px');
    });
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */
  function init() {
    // The script tag is included once per section, so guard against the
    // browser executing it multiple times and double-binding handlers.
    if (window.__bvoyInitialized) return;
    window.__bvoyInitialized = true;

    initReveal();
    initCountUp();
    initHeroThoughts();
    initWeightLossChart();
    initAccordion();
    initSmoothScroll();

    measureThemeHeader();
    // Re-measure after the theme finishes laying out its own header
    // (it sets --header-height via its own scripts after load).
    window.addEventListener('load', measureThemeHeader);
    setTimeout(measureThemeHeader, 300);
    setTimeout(measureThemeHeader, 1000);
    window.addEventListener('resize', measureThemeHeader);
    // Re-measure on scroll in case the sticky header changes height when pinned.
    window.addEventListener('scroll', measureThemeHeader, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
